import auth from "./auth";

export default (router, store) => {
  auth(router, store);
};
